// Locale-aware accessors for the /[lang]/hotels page's hand-written copy. Same
// approach as citiesHubCopy (cities-hub-content.ts): read off the imported
// resource JSON directly, since `intro` / `faq` are arrays (no `returnObjects`
// dance through t()).

import type { Locale } from '@todo/core/i18n/locales';
import en from '@/lib/i18n/resources/en.json';
import fr from '@/lib/i18n/resources/fr.json';
import ru from '@/lib/i18n/resources/ru.json';

export type HotelsPageFaqEntry = { q: string; a: string };

export type HotelsPageCopy = {
  intro: string[];
  /**
   * Per city id: its name in this language (the map's town buttons — the
   * `cities` constant only has the French/English one) and a paragraph on
   * which part of town to stay in and who it suits.
   */
  cities: Record<string, { name: string; text: string }>;
  faqHeading: string;
  faq: HotelsPageFaqEntry[];
};

type HotelsPageResource = { hotelsPage: HotelsPageCopy };

const resources: Record<Locale, HotelsPageResource> = { en, fr, ru };

export function hotelsPageCopy(locale: Locale): HotelsPageCopy {
  return resources[locale].hotelsPage;
}
